import UserContext from "../infrastructure/UserContext";
import IMASLog from "../infrastructure/IMASLog";
import Utils from "../infrastructure/Utils";
import loggedInUser from '../infrastructure/Auth0Authenticator';

export enum MarketerEventType {
  Call = 1,
  Email = 2
}

export interface MarketerEventRequest {
  icAgentId: number | null;
  phoneNumber: string;
  userEmail: string;
  eventTypeId: MarketerEventType;
  campaignId: number | null;
  tenantName: string;
}

class MarketerEventStore {
  private readonly baseUrl: string;

  constructor() {
    const env = Utils.getAppHostKey();
    this.baseUrl = `https://marketer-${env}.integrityconnect.com`.replace("-prod", "");
  }

  private async postEvent(request: MarketerEventRequest, impersonatedUser?: number) {
    const url = `${this.baseUrl}/dialer/call`;
    const hostname = window.location.host;
    return fetch(url, {
      method: 'POST',
      headers: {
        "Impersonated_User": impersonatedUser == null ? "" : String(impersonatedUser),
        "HOSTNAME": hostname == null ? "" : String(hostname),
        "Content-Type": "application/json",
        "Accept": "text/plain",
        "tenantName": Utils.getBUName()
      },
      body: JSON.stringify(request)
    });
  }

  private buildRequest(agentId: number | undefined, phoneNumber: string | undefined, eventType: MarketerEventType): MarketerEventRequest {
    return {
      icAgentId: agentId || null,
      userEmail: loggedInUser.userName,
      phoneNumber: phoneNumber || "",
      eventTypeId: eventType,
      campaignId: null,
      tenantName: Utils.getBUName()
    };
  }

  public async logEvent(agentId: number | undefined, phoneNumber: string | undefined, eventType: MarketerEventType): Promise<boolean> {
    try {
      const impersonatedUser = UserContext.getUserId();
      const request = this.buildRequest(agentId, phoneNumber, eventType);
      const result = await this.postEvent(request, impersonatedUser);
      if (!result.ok) {
        Utils.showWarningToaster("Error launching RingCentral. Please try again.", 4000);
        IMASLog.log(`marketer event failed: ${result.status} ${result.statusText || ''}`);
        return false;
      }
      return true;
    } catch (e) {      
      Utils.showWarningToaster("Error launching RingCentral. Please try again.", 4000);
      IMASLog.log("marketer event exception: " + e);
      return false;
    }
  }
}

export default new MarketerEventStore();